import { inject } from '@vercel/analytics';
import '../sass/main.scss';
import canvasDotsBg from '../bgCanvas.js';
import setupMobileNav from '../nav.js';
import news from '../config/news';

// Initialize Vercel Analytics
inject();

window.onload = function () {
  canvasDotsBg();
  setupMobileNav();
  renderNews();
  setupScrollReveal();
};

function renderNews() {
  const timeline = document.getElementById('news-timeline');
  if (!timeline) return;

  timeline.innerHTML = news
    .map((item, i) => {
      // Dates are plain YYYY-MM-DD strings (UTC midnight); format them in UTC
      // so the shown day never shifts with the visitor's time zone.
      const dateStr = new Date(item.date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC',
      });
      const target = /^https?:\/\//.test(item.link) ? '_blank' : '_self';
      // Everything after the first card starts below the fold.
      const lazyAttrs = i > 0 ? ' loading="lazy" decoding="async"' : ' decoding="async"';
      const imageHtml = item.image
        ? `<div class="news-card__image"><img src="${item.image}" alt="${item.title}"${lazyAttrs} /></div>`
        : '';
      const revealDir = i % 2 === 0 ? 'reveal-left' : 'reveal-right';

      return `
      <div class="news-item ${revealDir} reveal--delay-${(i % 4) + 1}">
        <a href="${item.link}" class="news-card" target="${target}" rel="noopener noreferrer">
          ${imageHtml}
          <div class="news-card__body">
            ${item.badge ? `<div class="news-card__badge">${item.badge}</div>` : ''}
            <div class="news-card__date">${dateStr}</div>
            <h3 class="news-card__title">${item.title}</h3>
            <p class="news-card__description">${item.description}</p>
            <span class="news-card__link">Read More &rarr;</span>
          </div>
        </a>
      </div>`;
    })
    .join('');
}

function setupScrollReveal() {
  const reveals = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { root: null, rootMargin: '0px', threshold: 0.15 }
  );
  reveals.forEach((el) => observer.observe(el));
}
